<template>
  <div class="seller-contract">
    <div class="seller-top">
      <div class="top-con">
        <div class="container">
          <img src="@/assets/image/Contract/sell_info.png"/>
          <!-- <span>订单编号：{{ form.order_sn }}</span> -->
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="seller-main">
      <div class="form">
        <el-form ref="form" label-position="top" label-width="200px" :model="form" :rules="rules">
          <!-- <div class="contract_order_sn">
            订单编号：{{ form.order_sn }}
          </div> -->
          <!-- <el-form-item prop="source" class="contract_radio">
            <div slot="label" class="item-label">
              <i>您是从哪里知晓游严选游戏服务网的？</i>
              <i class="item-radio">(单选)</i>
            </div>
            <el-radio  label="1" v-model="form.source">贴吧</el-radio>
            <el-radio  label="2" v-model="form.source">主播</el-radio>
            <el-radio  label="3" v-model="form.source">号商</el-radio>
            <el-radio  label="4" v-model="form.source">朋友推荐</el-radio>
            <el-radio  label="5" v-model="form.source">网页搜索</el-radio>
            <el-radio  label="6" v-model="form.source">小程序公众号</el-radio>
            <el-radio  label="7" v-model="form.source">抖音</el-radio>
            <el-radio  label="8" v-model="form.source">B站(bilbili)</el-radio>
            <el-radio  label="9" v-model="form.source">老客户</el-radio>
            <el-radio  label="0" v-model="form.source">其他</el-radio>
          </el-form-item> -->
          <el-form-item label="卖家姓名" prop="sell_name">
            <el-input placeholder="请输入姓名" v-model="form.sell_name" @change="changeInfo('sell_name')"></el-input>
          </el-form-item>
          <el-form-item label="卖家手机号1" prop="sell_mobile">
            <el-input placeholder="请输入联系电话" v-model="form.sell_mobile" @change="changeInfo('sell_mobile')"></el-input>
          </el-form-item>
          <el-form-item label="卖家手机号2" prop="sell_standby_mobile">
            <el-input placeholder="请输入联系电话" v-model="form.sell_standby_mobile" @change="changeInfo('sell_standby_mobile')"></el-input>
          </el-form-item>
          <el-form-item label="收款账号" prop="charge_account">
            <el-input placeholder="请输入收款账号" v-model="form.charge_account" @change="changeInfo('charge_account')">
              <el-select v-model="form.charge_account_type" slot="append" placeholder="请选择" @change="changeInfo('charge_account_type')">
                <el-option label="支付宝" :value="0"></el-option>
                <el-option label="微信" :value="1"></el-option>
                <el-option label="银行卡" :value="2"></el-option>
              </el-select>
            </el-input>
            <div class="point">
              默认支付宝收款，其他收款方式请重新选择，<span>一经放款概不负责！</span>
            </div>
          </el-form-item>
          <el-form-item label="商品编号" prop="unique_no">
            <el-input v-model="form.unique_no" disabled></el-input>
          </el-form-item>
          <el-form-item label="关联游戏" prop="game_name">
            <el-input v-model="form.game_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="游戏账号" prop="game_account">
            <el-input placeholder="请输入游戏账号" v-model="form.game_account" @change="changeInfo('game_account')"></el-input>
          </el-form-item>
          <el-form-item label="转让价格" prop="transfer_price">
            <el-input placeholder="请输入联系电话" v-model="form.transfer_price" @change="changeInfo('transfer_price')"></el-input>
          </el-form-item>
          <el-form-item label="首任/非首任" prop="first" class="form-sell-first">
            <el-radio v-model="form.first" :label="1">首任</el-radio>
            <el-radio v-model="form.first" :label="0">非首任</el-radio>
          </el-form-item>
        </el-form>
        <div class="fdd-tip">
          <!-- <img src="@/assets/image/Contract/fddTip.png"/> -->
          <i class="el-icon-warning"></i>
          提示：{{tip}}
        </div>
      </div>
      <div class="seller-btn">
        <el-button type="primary" :disabled="noSave" @click="save()" class="sub">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apibenefitCheckUpdate,
  apibenefitCheckDetails
  } from "../../request/API";
/**
 * 表单验证失败时 滚动到第一个error位置
 */
const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};
export default {
  name: 'sellerContract',
  data() {
    return {
      loading: false,
      loadingback: false,
      form: {
        charge_account_type: 0,
        sell_name: '',
        sell_mobile: '',
        sell_standby_mobile: '',
        charge_account: '',
        unique_no: '',
        game_account: '',
        transfer_price: '',
        first: '',
        game_id: '',
        game_name: ''
      },
      id: '',
      noSave:false,
      changeInfoForm: {},
      update_fields: [],
      status: '',
      number: '',
      tip: '',
      rules: {
        sell_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          { max: 30, message: '姓名不得超过30个汉字', trigger: 'blur' }
        ],
        sell_mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min:11, max: 11, message: '请输入11位手机联系号码', trigger: 'blur' }
        ],
        // sell_standby_mobile: [
        //   {required: true, message: '请输入联系电话', trigger: 'blur'},
        //   {min:11, max: 11, message: '请输入11位手机联系号码', trigger: 'blur' }
        // ],
        game_account: [
          {required: true, message: '请输入游戏账号', trigger: 'blur'},
        ],
        unique_no: [
          {required: true, message: '请联系客服咨询商品编号', trigger: 'blur'},
        ],
        game_name: [
          {required: true, message: '请联系客服', trigger: 'blur'},
        ],
        transfer_price: [
          {required: true, validator: this.validatearmsData, trigger: 'blur'},
        ],
        charge_account: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
          { max: 70, message: '收款账号不得超过70个字符', trigger: 'blur' }
        ],
        first: [
          {required: true, message: '请选择选项', trigger: 'change'},
        ],
      },
      frontIdPhotoShow: true,
      backIdPhotoShow: true,
      nameShow: false,
      cardIdShow: false,
      userToken: '',
      app_status: 1
    }
  },
  created() {
    this.userToken = this.$route.query?.t || this.$route.query?.token
    this.id = this.$route.query.benefit_id
    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?benefit_id='+this.form.id,
          },
        })
        return;
      }
    }

    apibenefitCheckDetails(this.app_status,{id:this.id}).then(res => {
      if (this.$store.state.loginStatus){
        if(this.userToken){
        } else {
          let tel = res.data.sell_mobile
          if(tel !== this.$store.state.userData.telphone){
            let telStart = tel.substring(0,3)
            let telEnd = tel.substring(7,11)
            this.$alert('当前用户无此核对信息，请登录'+ telStart + '****' + telEnd +'后核对提交。',{
              confirmButtonText: '确定',
              center: true,
              showClose: false
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  Rurl: this.$route.path+'?benefit_id='+this.id,
                },
              })
            }).catch(() => {})
            return
          }
        }
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?benefit_id='+this.id,
          },
        })
      }
      this.form = {...res.data}
      this.changeInfoForm = {...res.data}
      this.status = res.data.status
      this.number = res.data.number
      if(this.status == 1){
        this.tip = '订单信息已核对，无法提交'
        this.noSave = true
        return
      }
      if(this.status!=1&&this.number<3){
        this.tip = `已提交${this.number}次，最多提交3次`
      }
      if(this.status!=1&&this.number>=3){
        this.tip = `已提交${this.number}次，无法提交`
        this.noSave = true
        return
      }
    }).catch(() => {
      this.$message.error('服务器异常')
    })
  },
  watch: {
    'form.first'(val) {
      if(this.form.first!=this.changeInfoForm.first){
        if(this.update_fields.indexOf('first') !== -1){
          this.update_fields.splice(this.update_fields.indexOf('first'), 1)
        }
        this.update_fields.push('first')
      }
    }
  },
  methods: {
    /**
     * @description: 记录用户修改字段
     * @return {*}
     */
    changeInfo(field) {
      for (const key in this.changeInfoForm) {
        if(field == key&&this.form[field]!=this.changeInfoForm[key]){
          if(this.update_fields.indexOf(key) !== -1){
            this.update_fields.splice(this.update_fields.indexOf(key), 1)
          }
          this.update_fields.push(field)
        }
      }
    },
    validatearmsData(rule, value, callback) {
      if(value.length == 0){
        return callback(new Error('请输入转让价格！'));
      }
      if (isNaN(value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (value > 1000000) {
          callback(new Error('转让价格必须小于一百万！'));
        } else {
          callback();
        }
      }
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          apibenefitCheckUpdate(this.app_status,{
            ...this.form,
            id:this.id,
            update_fields: JSON.stringify(this.update_fields),
          }).then(res => {
            if(res.code == 200){
              window.open(process.env.VUE_APP_WEBSITE, '_self')
            }else{
              this.$message({
                message: res.msg,
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            }
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
          })
        }else{
          scrollIntoView()
          this.$message({
            message: '还有未填项',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },
  }
}
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page();
</style>
